import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { requestIcon } from '../constants';

const RequestIcon = ({ allowTransfer, request }) => {
  const intl = useIntl();
  const { icon, message, color } = requestIcon(request, allowTransfer);

  return (
    <Icon
      name={icon}
      className={color}
      title={request.error_message || intl.formatMessage({ id: message })}
    />
  );
};

export default RequestIcon;
